<div class="search-modal-container"><app-search-bar></app-search-bar></div>
